import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import * as amplitude from "@amplitude/unified";

amplitude.initAll(process.env.REACT_APP_AMPLITUDE_API_KEY, {
  analytics: {
    remoteConfig: { fetchRemoteConfig: true }, // pull remote SDK config from Amplitude
    autocapture: {
      attribution: true,              // UTM / referrer attribution events
      pageViews: true,                // SPA route changes + initial page load
      sessions: true,                 // Session start / end events
      formInteractions: true,         // Form starts + submits
      fileDownloads: true,            // Downloads of common file types
      elementInteractions: true,      // Clicks + changes on instrumented elements
      frustrationInteractions: true,  // Rage clicks, dead clicks
      pageUrlEnrichment: true,        // Adds path / search params to event props
      networkTracking: true,          // XHR + fetch request events
      webVitals: true,                // Core Web Vitals (LCP, INP, CLS)
    },
  },
  sessionReplay: { sampleRate: 1 }, // Record user sessions; lower sampleRate in production if needed
  engagement: {},                    // In-product Guides & Surveys
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
